module.exports = __webpack_public_path__ + "static/WeekendWeddingBrochure-6fc1a16533f3b3cba96e6926a14e8f43.pdf";